import { isSkillSyncInProgress } from "../../../shared/mutators/resyncSkill";

export type InstallGitSkillsProgress =
  | { status: "pending" }
  | { status: "failed"; error: string }
  | { status: "installed" };

type Installation = {
  syncStartedAt: number | null;
  lastError: string | null;
  skill?: { fresh: boolean } | undefined;
};

export function installGitSkillsProgress(
  installations: readonly Installation[],
  submittedCount: number,
  now: number
): InstallGitSkillsProgress {
  if (installations.length !== submittedCount) {
    return { status: "pending" };
  }

  if (
    installations.some((installation) =>
      isSkillSyncInProgress(installation.syncStartedAt, now)
    )
  ) {
    return { status: "pending" };
  }

  const errors = installations.flatMap((installation) =>
    installation.lastError ? [installation.lastError] : []
  );
  if (errors.length > 0) {
    return { status: "failed", error: [...new Set(errors)].join(" ") };
  }

  if (
    installations.some((installation) => installation.syncStartedAt !== null)
  ) {
    return {
      status: "failed",
      error: "Installation timed out. Retry installation.",
    };
  }

  if (
    installations.every((installation) => installation.skill?.fresh === false)
  ) {
    return { status: "installed" };
  }

  return { status: "pending" };
}
